import { Card } from "@/components/ui/card";
import { ServiceBadge } from "./service-badge";
import { ArrowRightIcon } from "@heroicons/react/16/solid";

export const SpecialtyCard = ({ specialty }) => {
    const serviceTags = specialty.serviceTags.split(", ");

    return (
        <Card className="flex h-full flex-col gap-0">
            <p className="mb-2 text-lg font-semibold">
                {specialty.professionTitle}
            </p>
            <p className="mb-4 text-sm text-neutral-500">
                {specialty.professionDescription}
            </p>

            <div className="mb-4 flex flex-wrap gap-1">
                {serviceTags.map((serviceTag, id) => (
                    <ServiceBadge key={id} serviceTag={serviceTag} size="xl" />
                ))}
            </div>
            <hr className="mt-auto mb-4 h-px w-full border-gray-200" />
            <div className="flex text-xs">
                <ArrowRightIcon className="me-2 mt-0.5 size-4 shrink-0 text-green-600" />
                <span>
                    <b>See one if</b> {specialty.seeOneIf}
                </span>
            </div>
        </Card>
    );
};
